// this component was automatically generated by IconGlyph.template.js
import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useFeatureGate } from '@trello/feature-gate-client';
import { useLazyComponent } from '@trello/use-lazy-component';

import { Icon } from '../components/Icon';
import type { Color, GlyphProps } from '../components/Icon/Icon.types';

const TableIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 14 10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66683 9.66665C0.93045 9.66665 0.333496 9.06969 0.333496 8.33331V1.66665C0.333496 0.930267 0.93045 0.333313 1.66683 0.333313H12.3335C13.0699 0.333313 13.6668 0.930267 13.6668 1.66665V8.33331C13.6668 9.06969 13.0699 9.66665 12.3335 9.66665H1.66683ZM12.3335 5.66665V4.33331H5.66683V5.66665H12.3335ZM12.3335 2.99998V1.66665H5.66683V2.99998H12.3335ZM12.3335 6.99998V8.33331H5.66683V6.99998H12.3335ZM1.66683 4.33331V5.66665H4.3335V4.33331H1.66683ZM1.66683 6.99998V8.33331H4.3335V6.99998H1.66683ZM1.66683 2.99998V1.66665H4.3335V2.99998H1.66683Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TableIcon: FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label, block } = props;
  const { value: isIconFlagEnabled } = useFeatureGate('trello_ads_icons');

  const LazyAdsIcon = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "ADS-TableIcon" */ '@atlaskit/icon/core/spreadsheet'
      ),
    { namedImport: 'default', preload: false },
  );

  const adsIconSize = size === 'medium' || size === 'small' ? size : undefined;

  return isIconFlagEnabled ? (
    <span className={dangerous_className}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-ghost',
          feature: 'ADS Icon',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <Suspense fallback={null}>
            <LazyAdsIcon
              label={label || ''}
              testId={testId || 'TableIcon'}
              color={color as Color}
              size={adsIconSize}
            />
          </Suspense>
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </span>
  ) : (
    <Icon
      testId={testId || 'TableIcon'}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      block={block}
      label={label}
      glyph={TableIconGlyph}
    />
  );
};
